import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import api from '../../services/api';
import { getToken, getUserType, getUserId, logout, isAuthenticated } from "../../services/auth";

import Header from '../../components/header';
import TitlePage from '../../components/title-page';
import ListProject from 'pages/list-projects';

export default class Main extends Component {
	state = {
		redirect: false,
		loadingPage: true,
		user_type: "",
		search: "",
		company_list: [],
		company_list_opened: false,
		company_selected: "",
		company_id: "",
		company_name: "",
		projects: [],
		submissionLists: [],
		loading_projects: true,
		modal_delete: "closed",
		modal_beta: "closed",
		selected_project: ""
	};

	constructor(props) {
		super(props);
		this.escFunction = this.escFunction.bind(this);
	}

	componentDidMount() {
		// Verificar token antes de continuar
		const token = getToken();
		if (!token) {
			this.setState({ redirect: true });
			return;
		}

		document.querySelector('body').classList.remove("no-scroll");

		const currentUser = getUserType();
		const selectedCompany = localStorage.getItem("company_selected");
		const beta_already_shown = localStorage.getItem("beta");

		if (beta_already_shown === null) {
			this.modalBeta("opened");
		}

		if (currentUser === "admin") {
			this.setState({ user_type: "admin" });
			this.loadApiCompany(selectedCompany);
		} else {
			this.setState({ user_type: "normal" });
			this.loadApiUser();
		}

		document.addEventListener("keydown", this.escFunction, false);
	}

	componentWillUnmount() {
		document.removeEventListener("keydown", this.escFunction, false);
		// Previene setState después de unmount
		this.setState = () => {};
	}
loadLists = async _ => {
		try {
			const {company_id, project_id} = this.state
			const responseList = await api.get(`/companies/${company_id}/projects/${project_id}/submission-lists`)

			const submissionLists = responseList.data || []
			const contactsPromises = submissionLists.map(this.loadSubmissionListContacts)
			let contacts = await Promise.all(contactsPromises);

			const tempList = await responseList.data.filter( item => {
				if(item.contacts.length > 0) {
					return item;
				}
			});
			this.state.submissionLists.map(submissionList => (
				console.log("loadList" + submissionList.cc)
			))

			await this.setState({
				submissionLists: tempList,
				contacts,
				loading_lists: false
			});
		} catch (error) {
			console.log(error);
		}
	}
	escFunction(event) {
		if (event.keyCode === 27) {
			const elements = document.querySelectorAll(".card-container .options");
			elements.forEach(element => {
				if (element.classList.contains('opened')) {
					element.classList.remove("opened");
					element.classList.add("closed");
				}
			});
			this.setState({ company_list_opened: false });
		}
	}

	loadApiCompany = async (selectedCompany) => {
		try {
			const response = await api.get(`app_users?filter[include]=companies`);
			const list = [];
			response.data.map(company => {
				if (company.active) {
					company.companies.map(companie => list.push(companie));
				}
			});

			if (selectedCompany === null) selectedCompany = 0;

			let selected_item = [];
			if (selectedCompany !== 0) {
				selected_item = list.find(item => parseInt(item.id) === parseInt(selectedCompany)) || list[0];
			} else {
				selected_item = list[0];
			}

			if (!selected_item) {
				console.warn("No hay compañías activas");
				this.setState({ loadingPage: false, loading_projects: false });
				return;
			}

			this.setState({
				company_list: list,
				company_id: selected_item.id,
				company_name: selected_item.name,
				company_selected: selected_item.id
			});

			this.loadApiProject(selected_item.id);
		} catch (error) {
			if (error.response && error.response.status === 401) {
				logout();
				this.setState({ redirect: true });
			} else {
				console.error("Error cargando compañías:", error);
				// limpiar selección y reintentar con null
				localStorage.removeItem("company_selected");
				try { this.loadApiCompany(null); } catch(e) { /* ignore */ }
			}
		}
	};

	loadApiUser = async () => {
		const token = getToken();
		const userId = getUserId();

		try {
			const response = await api.get(`app_users/${userId}?filter[include]=companies&access_token=${token}`);

			if (!response.data.companies || response.data.companies.length === 0) {
				console.warn("El usuario no tiene compañías asociadas");
				this.setState({ loadingPage: false, loading_projects: false });
				return;
			}

			this.setState({
				company_id: response.data.companies[0].id
			});

			this.loadApiProject(response.data.companies[0].id);
		} catch (error) {
			if (error.response && error.response.status === 401) {
				logout();
				this.setState({ redirect: true });
			} else {
				console.error("Error cargando usuario:", error);
			}
		}
	};

	loadApiProject = async (company_id) => {
		// scroll top
		document.body.scrollTop = 0;
		document.documentElement.scrollTop = 0;

		this.setState({ loading_projects: true });

		try {
			const response = await api.get(`companies/${company_id}/projects`);

			if (response.data && response.data.length > 0) {
				let tempProjects = response.data;

				// obtener banners en serie (podrías paralelizar si lo deseas)
				for (const item of tempProjects) {
					try {
						const response2 = await api.get(`companies/${company_id}/projects/${item.id}/banner`);
						item.banner_src = response2.data && response2.data.image_url ? `https://seat7-uploads.s3.amazonaws.com/${response2.data.image_url}` : null;
					} catch {
						item.banner_src = null;
					}
				}

				this.setState({
					projects: tempProjects,
					loadingPage: false,
					loading_projects: false
				});
			} else {
				this.setState({
					loadingPage: false,
					loading_projects: false,
					projects: []
				});
			}
		} catch (error) {
			if (error.response && error.response.status === 401) {
				logout();
				this.setState({ redirect: true });
			} else {
				console.error("Error cargando proyectos:", error);
				// mantener loaderPage false para no bloquear la UI
				this.setState({ loadingPage: false, loading_projects: false });
			}
		}
	};

	onChange = (e) => {
		this.setState({
			[e.target.name]: e.target.value,
		});
	};

	hendleSearch = (e) => {
		e.preventDefault();
	};

	openCompanyList = () => {
		this.setState({ company_list_opened: !this.state.company_list_opened });
	};

	changeCompany = (id) => {
		let company_name = "";
		this.state.company_list.forEach(function (company) {
			if (company.id === id) company_name = company.name;
		});

		this.setState({
			company_selected: id,
			company_id: id,
			company_name: company_name,
		});

		localStorage.setItem("company_selected", id);
		this.loadApiProject(id);
	};

	openOptions = (e) => {
		// Mantener mismo comportamiento (cerrar otros y abrir el actual)
		const next = e.target.nextSibling;
		const elements = document.querySelectorAll(".card-container .options");
		elements.forEach(el => {
			if (el !== next && el.classList.contains('opened')) {
				el.classList.remove("opened");
				el.classList.add("closed");
			}
		});
		if (next.classList.contains("closed")) {
			next.classList.remove("closed");
			next.classList.add("opened");
		} else {
			next.classList.remove("opened");
			next.classList.add("closed");
		}
	};

	modalBeta(status) {
		this.setState({ modal_beta: status });
		localStorage.setItem('beta', true);
	}

	modalDelete(status, id) {
		this.setState({
			selected_project: id,
			modal_delete: status
		});
	}

	deletePoject = async (status, id) => {
		const tempProjects = this.state.projects.filter(item => item.id !== id);
		this.setState({ projects: tempProjects, modal_delete: status });

		try {
			await api.delete(`companies/${this.state.company_id}/projects/${id}`);
		} catch (error) {
			console.error("Error eliminando proyecto:", error);
		}
	};

	render() {
		if (this.state.redirect) {
			return <Redirect to='/Login' />;
		}

		
		if (this.state.loadingPage) {
			return (
				<div data-component="loader">
					<div className="dots-container">
						<div class="dot"></div>
						<div class="dot"></div>
						<div class="dot"></div>
						<div class="dot"></div>
						<div class="dot"></div>
					</div>
				</div>
			);
		}

		let link;
		let editLink;
		if (this.state.user_type === "admin") {
			link = "shipping-management";
			editLink = "edit-project";
		} else {
			link = "project-edit";
			editLink = "project-edit";
		}

		let company_selection;
		if (this.state.user_type === "admin") {
			company_selection = (
				<div className="company-selection">
					<Link to="/list-projects/1" className="btn blue">List Mode</Link>
					<p className="text">Projects Listed For</p>
					<div
						data-component="company-selection"
						className={`company-list-container ${this.state.company_list_opened ? "active" : ""}`}
						onClick={this.openCompanyList}
					>
						<p className="company-text">{this.state.company_name}</p>
						<div className="company-list">
							{this.state.company_list.map(company => (
								<button
									className={`company-item ${this.state.company_id === company.id ? "active" : ''}`}
									key={`company-${company.id}`}
									onClick={e => this.changeCompany(company.id)}
								>
									{company.name}
								</button>
							))}
						</div>
					</div>
				</div>
			);
		}

		const projectsTemplates = this.state.projects.filter(item => item.is_template === true);

		const templates = projectsTemplates.map(project => (
			<div className="card-container" key={project.id}>
				<Link to={`/create-project/${this.state.company_id}/${project.id}`} className="card">
					<span className="image">
						{project.banner_src && <img src={project.banner_src} alt={project.title} />}
					</span>
					<p className="title-card">Template: {project.title}</p>
				</Link>

				<button className="options-button" onClick={this.openOptions}></button>
				<div className="options closed">
					<Link className="btn" to={`/${editLink}/${this.state.company_id}/${project.id}`}>Edit</Link>
					<button className="btn" onClick={() => this.modalDelete("opened", project.id)}>Delete</button>
				</div>
			</div>
		));

		const renderProjectCard = (project) => (
			<div className="card-container" key={`collaborator-${project.id}`}>
				<Link to={`/${link}/${this.state.company_id}/${project.id}`} className="card">
					<span className="image">
						{project.banner_src && <img src={project.banner_src} alt={project.title} />}
					</span>
					<div className="title-card">
						<p className="text">{project.title}</p>
						<span className="data">Last update: {project.updated_at ? project.updated_at.substr(0, 10) : "—"}</span>
						{ this.state.submissionLists.map(submissionList => (
							
							<span className="data">Last update: {submissionList.sent_at}</span>
						))}
					</div>
				</Link>

				<button className="options-button" onClick={this.openOptions}></button>
				<div className="options closed">
					<Link className="btn" to={`/${editLink}/${this.state.company_id}/${project.id}`}>Edit</Link>
					<button className="btn" onClick={() => this.modalDelete("opened", project.id)}>Delete</button>
				</div>
			</div>
		);

		const projectsTemp = this.state.projects.filter(item => !item.is_template);
		const recentProjects = projectsTemp.filter(item => item.sent_to_publishers === false);
		const submittedProjects = projectsTemp.filter(item => item.sent_to_publishers === true);

		return (
			<div data-page="main">
				<Header />
				<TitlePage title="Projects" />

				<div className="container-fluid" data-component="main-content">
					<div className="container">
						<div className={`row actions ${this.state.user_type === "admin" ? "two-cols" : ""}`}>
							{company_selection}
						</div>

						<div className="row new-projects">
							<strong className="title">Start New Project</strong>
							<div data-component="list-cards">
								<div className="card-container">
									<Link to="/create-project/0/0" className="card new">
										<span className="image"></span>
										<p className="title-card">New Project</p>
									</Link>
								</div>
								{templates}
							</div>
						</div>

						<div className="row recent-projects">
							<strong className="title">Recent Projects</strong>
							<div data-component="list-cards">
								{recentProjects.length > 0 ? (
									recentProjects.map(renderProjectCard)
								) : this.state.loading_projects ? (
									<div className="loading-projects"></div>
								) : (
									<div className="no-projects">
										<p className="text">No Recent Projects</p>
									</div>
								)}
							</div>
						</div>

						{this.state.user_type === "admin" && (
							<div className="row recent-projects submited">
								<strong className="title">Submitted Projects</strong>
								<div data-component="list-cards">
									{submittedProjects.length > 0 ? (
										submittedProjects.map(renderProjectCard)
									) : this.state.loading_projects ? (
										<div className="loading-projects"></div>
									) : (
										<div className="no-projects">
											<p className="text">No projects Submitted</p>
										</div>
									)}
								</div>
							</div>
						)}
					</div>
				</div>

				<div data-component="modal" className={`modal-cancel ${this.state.modal_delete}`}>
					<div className="content">
						<p className="text">
							<b>Are you sure that you want to permanently delete this project?</b><br />
							<b>This will also delete any uploaded files. Be careful, this process cannot be undone.</b>
						</p>
						<button onClick={() => this.modalDelete('closed')} className="btn grey">No</button>
						<button onClick={() => this.deletePoject('closed', this.state.selected_project)} className="btn blue-light">Yes</button>
					</div>
				</div>

				<div data-component="modal" className={`modal-cancel ${this.state.modal_beta}`}>
					<div className="content">
						<p className="text">Welcome To The New Seat7 Platform.</p>
						<button onClick={() => this.modalBeta('closed')} className="btn grey">Enter</button>
					</div>
				</div>
			</div>
		);
	}
}
